import { render, staticRenderFns } from "./ManagementFeeIndex.vue?vue&type=template&id=67e028ec&scoped=true&"
import script from "./ManagementFeeIndex.vue?vue&type=script&lang=js&"
export * from "./ManagementFeeIndex.vue?vue&type=script&lang=js&"
import style0 from "./ManagementFeeIndex.vue?vue&type=style&index=0&id=67e028ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e028ec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67e028ec')) {
      api.createRecord('67e028ec', component.options)
    } else {
      api.reload('67e028ec', component.options)
    }
    module.hot.accept("./ManagementFeeIndex.vue?vue&type=template&id=67e028ec&scoped=true&", function () {
      api.rerender('67e028ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/management/ManagementFeeIndex.vue"
export default component.exports